import React, { useState } from 'react'
import { Menu } from 'primereact/menu'
import PropTypes from 'prop-types'
import styles from '../../../../css/modals/ModalRSDevice.module.css'
import { useTranslation } from 'react-i18next'

export default function MenuRS ({ data, componentsModalRS, setComponentsModalRS, activeIndex, setActiveIndex }) {
  console.log(data)
  const { t } = useTranslation('dashboardDevice')

  const [selected, setSelected] = useState(t('modalRxartSecure.item1'))

  let items

  if (data?.device?.license.includes('-RX')) {
    items = [
      {
        label: t('modalRxartSecure.item1'),
        icon: 'pi pi-desktop',
        className: selected === t('modalRxartSecure.item1') ? 'menu-active' : '',
        command: () => {
          setComponentsModalRS({
            parameters: false,
            devices: true,
            messages: false,
            actions: false,
            menu: true
          })
          setSelected(t('modalRxartSecure.item1'))
        }
      },
      {
        label: t('modalRxartSecure.item2'),
        icon: 'pi pi-cog',
        className: selected === t('modalRxartSecure.item2') ? 'menu-active' : '',
        command: () => {
          setComponentsModalRS({
            parameters: true,
            devices: false,
            messages: false,
            actions: false,
            menu: true
          })
          setSelected(t('modalRxartSecure.item2'))
        }
      },
      {
        label: t('modalRxartSecure.item3'),
        icon: 'pi pi-comment',
        className: selected === t('modalRxartSecure.item3') ? 'menu-active' : '',
        command: () => {
          setComponentsModalRS({
            parameters: false,
            devices: false,
            messages: true,
            actions: false,
            menu: true
          })
          setSelected(t('modalRxartSecure.item3'))
        }
      },
      {
        label: t('modalRxartSecure.item4'),
        icon: 'pi pi-arrow-right',
        className: selected === t('modalRxartSecure.item4') ? 'menu-active' : '',
        command: () => {
          setComponentsModalRS({
            parameters: false,
            devices: false,
            messages: false,
            actions: true,
            menu: true
          })
          setSelected(t('modalRxartSecure.item4'))
        }
      }
    ]
  } else {
    items = [
      {
        label: t('modalRxartSecure.item1'),
        icon: 'pi pi-desktop',
        className: selected === t('modalRxartSecure.item1') ? 'menu-active' : '',
        command: () => {
          setComponentsModalRS({
            parameters: false,
            devices: true,
            messages: false,
            actions: false,
            menu: true
          })
          setSelected(t('modalRxartSecure.item1'))
        }
      }
    ]
  }

  return (
        <div id="menuRS">
            <Menu model={items} className={styles.menu} />
        </div>
  )
}

MenuRS.propTypes = {
  data: PropTypes.object,
  componentsModalRS: PropTypes.object,
  setComponentsModalRS: PropTypes.func,
  activeIndex: PropTypes.number,
  setActiveIndex: PropTypes.func
}
